<template>
  <div id="index">
    <common-header></common-header>
      <!-- メッセージ -->
      <div v-if="isError">
        <v-alert
          :value="true"
          type="error"
          outline
        >
          {{errorMessage}}
        </v-alert>
      </div>
      <!-- /メッセージ -->
      <p v-if="isLoading" style="text-align:center;margin:30% 0;"><v-progress-circular class="isLoading" :size="70" :width="7" color="primary" indeterminate></v-progress-circular></p>
      <div v-else style="margin:0 10px 0 10px;">
        <v-layout row wrapper>
          <v-flex xs4 class="topIcon">
            <v-avatar :size="90" color="grey lighten-4">
              <img :src="userInfo.photoURL">
            </v-avatar>
          </v-flex>
          <v-flex xs8>
            <p class="topName">{{userInfo.displayName}}</p>
          </v-flex>
        </v-layout>
        <div class="block">
          <p class="label">URL</p>
          <p class="content">{{userInfo.url}}</p>
        </div>
        <div class="block">
          <p class="label">自己紹介</p>
          <p class="content">
            <span v-if="userInfo.introduction" v-html="$options.filters.changeBr(userInfo.introduction)"></span>
          </p>
        </div>
        <div v-if="idOwner" class="block" style="border:none;">
         <v-btn block large color="red" dark @click="onEdit">プロフィールを更新する</v-btn>
        </div>
        <v-list two-line v-if="records.length>0" style="max-width:700px;margin: 0 auto;">
          <template v-for="(r,id) in records">
            <v-list-tile :key="id" avatar @click="onRecordClick(r.id)" class="record-wrapper">
              <!-- <v-list-tile-avatar><img :src="r.profileImageUrl"></v-list-tile-avatar> -->
              <v-list-tile-avatar tile size="70">
                <v-img :src="r.imageUrl" aspect-ratio="1"></v-img>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-sub-title>
                  <v-chip v-if="r.coEdit" dark color="red accent-1" small>みんなの年表</v-chip>
                  <strong v-else>{{r.displayName}}</strong>
                  {{r.timestamp | displayDate}}
                </v-list-tile-sub-title>
                <v-list-tile-title v-html="r.title + 'の年表'" class="mincho title"></v-list-tile-title>
                <v-list-tile-sub-title>
                  <v-chip v-if="!r.release" small label dark color="red accent-1">
                    非公開
                  </v-chip>
                  <v-chip v-if="r.comment_count>0" small label outline color="red accent-1">
                    <v-icon small>comment</v-icon>&nbsp;{{r.comment_count}}
                  </v-chip>
                  {{r.message | textTrim}}
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>
        </v-list>
        <div v-if="!isLoading" style="width:100%;text-align:center;">
          <v-btn v-if="!isMax" color="red" large dark @click="onMore">もっと見る</v-btn>
        </div>
      </div>
    <common-footer></common-footer>
    <post-button></post-button>
  </div>
</template>

<script>
import { db } from '../../main'
import firebase from 'firebase'
import CommonHeader from '../common/CommomHeader'
import CommonFooter from '../common/CommomFooter'
import PostButton from '../common/PostButton'
export default {
  name: 'Profile',
  data () {
    return {
      isLoading: true,
      isError: false,
      errorMessage: '',
      id: '',
      userInfo: {},
      limit: 20,
      lastObj: undefined,
      records: [],
      isMax: false
    }
  },
  computed: {
    isLogin () {
      return this.$store.state.view.isLogin
    },
    idOwner () {
      if (this.isLogin && this.id === firebase.auth().currentUser.uid) return true
      return false
    }
  },
  mounted () {
    this.id = this.$route.params.id
    this.getUserInfo()
    this.getUserPosts()
  },
  methods: {
    getUserInfo () {
      db.collection('user').doc(this.id).get().then((doc) => {
        if (doc.exists) {
          this.userInfo = doc.data()
          this.isLoading = false
        } else {
          this.isError = true
          this.errorMessage = '存在しないURLです。'
        }
      })
        .catch((e) => {
          this.isError = true
          this.errorMessage = '存在しないURLです。'
        })
    },
    getUserPosts () {
      let dbRef = db.collection('chronology').where('uid', '==', this.id)
      if (!this.idOwner) {
        dbRef = dbRef.where('release', '==', true)
      }
      dbRef = dbRef.orderBy('timestamp', 'desc')
      if (this.lastObj !== undefined) {
        dbRef = dbRef.startAfter(this.lastObj)
      }
      dbRef.limit(this.limit).get().then((snapshot) => {
        snapshot.forEach((doc) => {
          let obj = doc.data()
          obj.id = doc.id
          if (obj.image) {
            let fname = `chronology/${doc.id}/${obj.image}`
            let encodeFname = encodeURIComponent(fname)
            let imageUrl = `https://firebasestorage.googleapis.com/v0/b/heisei.appspot.com/o/${encodeFname}?alt=media`
            obj.imageUrl = imageUrl
          } else {
            obj.imageUrl = 'https://www.katsulabo.com/heisei/image/icon2.png'
          }
          this.records.push(obj)
        })
        if (snapshot.docs.length === this.limit) {
          this.lastObj = snapshot.docs[snapshot.docs.length - 1]
          this.isMax = false
        } else {
          this.isMax = true
        }
      })
    },
    onMore () {
      this.refresh()
    },
    onRecordClick (id) {
      this.$router.push({name: 'Chronology', params: {id: id}})
    },
    onEdit () {
      this.$router.push({name: 'EditProfile', params: {obj: {id: this.id, userInfo: this.userInfo}}})
    }
  },
  filters: {
    textTrim: function (value) {
      let max = 30
      if (value.length >= 30) return value.substring(0, max - 1) + '...'
      return value
    },
    changeBr: function (value) {
      return String(value).replace(/\r?\n/g, '<br>')
    },
    displayDate (value) {
      let date = new Date()
      let now = date.getTime()
      date.setTime(value.seconds * 1000)
      let diff = (now - value.seconds * 1000) / (60 * 1000) // 分
      if (diff < 60) {
        return `${Math.floor(diff)}分前`
      } else if (diff < 24 * 60) {
        return `${Math.floor(diff / 60)}時間前`
      } else {
        return `${date.getMonth() + 1}月${date.getDate()}日`
      }
    }
  },
  components: {
    CommonHeader,
    CommonFooter,
    PostButton
  }
}
</script>

<style scoped>
@import url("../../assets/css/common.css");
.wrapper{
  margin: 16px auto 0 auto;
  width: 100%;
  max-width: 700px;
}
.topIcon{
  text-align: center;
}
.topName{
  margin-top: 30px;
  margin-bottom: 5px;
  font-size: 140%;
  font-weight: bold;
}
div.block {
  margin: 32px auto 32px auto;
  width: 100%;
  max-width: 700px;
  border-bottom: dotted 1px #aaa;
}
p.label {
  margin-bottom: 0px;
  padding-bottom: 0px;
  font-size: 80%;
  color: #999999;
}
p.content {
  margin-bottom: 0px;
  padding-bottom: 0px;
  font-size: 110%;
}
.headline{
  margin-top: 16px;
  margin-bottom: 10px;
}
.isLoading{
  margin: 100px auto 0 auto;
}
.block-top{
  margin-top: 10%;
  margin-bottom: 10%;
  width: 100%;
}
.block-subtitle {
  padding:0 20px;
  margin:0 auto;
  margin-bottom:10px;
}
.v-list__tile__title {
  height: 30px !important;
  padding-top: 4px;
}
.record-wrapper{
  padding-bottom:10px;
  margin-bottom: 10px;
  margin-top: 10px;
  border-bottom: 1px dashed #bbb;
}
.v-list__tile__avatar {
  min-width:76px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/auth/Profile.vue